'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _roles = require('config/permissions/roles');

var _regulatorAddForm = require('./regulator-add-form/regulator-add-form.module');

var _regulatorAddForm2 = _interopRequireDefault(_regulatorAddForm);

var _regulatorEditForm = require('./regulator-edit-form/regulator-edit-form.module');

var _regulatorEditForm2 = _interopRequireDefault(_regulatorEditForm);

var _regulator = require('./regulator.component');

var _regulator2 = _interopRequireDefault(_regulator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.regulator', [_angularUiRouter2.default, _regulatorAddForm2.default, _regulatorEditForm2.default]).component('regulator', _regulator2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('regulator', {
    parent: 'app',
    url: '/regulators/{id:int}',
    component: 'regulator',
    data: {
      permissions: {
        only: [_roles.COMPANY_ADMIN, _roles.SYS_ADMIN],
        redirectTo: 'dashboard'
      }
    },
    resolve: {
      accessLevels: function accessLevels(AuthService) {
        return AuthService.getAccessLevels();
      },
      regulator: function regulator(RegulatorService, $stateParams) {
        return RegulatorService.get($stateParams.id).then(function (r) {
          return r.data;
        });
      },
      user: function user(AccountService, AuthService, currentUser) {
        return AccountService.getAccount(currentUser.UserId).then(function (r) {
          return r.data;
        });
      },
      locked: function locked() {
        return true;
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/regulator/regulator.module.js